import { useTheme } from "../context/ThemeContext";
import { Monitor, BrainCircuit, Workflow } from "lucide-react";

const Services = () => {
  const { isDarkMode } = useTheme();

  const boxClass = `${isDarkMode ? 'bg-[#83329A]' : 'bg-[#A988D8]'} p-6 rounded-lg w-full sm:w-[300px] md:w-[320px] lg:w-[350px] text-center shadow-lg transition-all duration-300 ease-in-out hover:${isDarkMode ? 'bg-[#A988D8]' : 'bg-[#83329A]'} hover:scale-105`;
  
  const iconClass = `mx-auto mb-4 ${isDarkMode ? 'text-white' : 'text-gray-800'} transition-colors duration-300`;
  
  const textClass = isDarkMode ? 'text-white' : 'text-gray-800';
  const descriptionClass = `${isDarkMode ? 'text-white' : 'text-gray-700'} mt-2 text-sm`;

  return (
    <section 
      className={`text-center py-10 ${isDarkMode ? 'bg-gray-900 text-white' : 'bg-gray-300 text-gray-800'} transition-colors duration-300`}
      id="services"
    >
      <h2 className="text-3xl font-bold" style={{ color: "#83329A" }}>
        Services
      </h2>
      <p className={`mt-2 mb-8 text-lg ${isDarkMode ? 'text-tertiary' : 'text-gray-600'} transition-colors duration-300`}>
        Here are the services I offer
      </p>
      <div className="flex flex-wrap justify-center gap-6 mt-8 px-4 max-w-6xl mx-auto">
        <div className={boxClass}>
          <BrainCircuit size={40} className={iconClass} />
          <h3 className={`text-lg font-bold ${textClass}`}>
            AI & LLM Development
          </h3>
          <p className={`font-bold ${textClass}`}>
            Building AI-Powered Solutions
          </p>
          <p className={descriptionClass}>
            Developing AI applications and LLM-based solutions using RAG, embedding models, and AI agents.
          </p>
        </div>
        <div className={boxClass}>
          <Monitor size={40} className={iconClass} />
          <h3 className={`text-lg font-bold ${textClass}`}>
            Software Development
          </h3>
          <p className={`font-bold ${textClass}`}>
            Functional & Scalable Applications
          </p>
          <p className={descriptionClass}>
            Creating functional software features and interfaces using modern development frameworks and technologies.
          </p>
        </div>
        <div className={boxClass}>
          <Workflow size={40} className={iconClass} />
          <h3 className={`text-lg font-bold ${textClass}`}>
            Security & Automation
          </h3>
          <p className={`font-bold ${textClass}`}>
            Improving Software Security
          </p>
          <p className={descriptionClass}>
            Automating vulnerability scanning and development workflows to identify security risks and improve software reliability.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Services;